import "../Coworkers/styles.scss";

import { API, Endpoints } from "utils/api";
import { ConfigProvider, Input, Pagination, Popconfirm, Table, notification } from "antd";
import { setBreadcrumb, setLoader } from "store/actions";

import { Footer } from "screens";
import { Helmet } from "react-helmet";
import { Icons } from "components";
import React from "react";
import Strings from "utils/strings";
import { connect } from "react-redux";
import en from "antd/es/locale/en_GB";
import pt from "antd/es/locale/pt_PT";
import { push } from "connected-react-router";

class Patients extends React.Component<any, any> {
	debounceTimer: any = null;

	constructor(props: any) {
		super(props);
		this.state = {
			patients: [],
			loading: true,
			page: 1,
			pageSize: 10,
			searchText: "",
			total: 0,
			searchInput: ""
		};
	}

	componentDidMount() {
		const { dispatch } = this.props;
		dispatch(
			setBreadcrumb(() => ({
				locations: [
					{
						text: Strings.sidebar.patients,
						route: "/patients"
					}
				]
			}))
		);
		this.getData();
	}

	componentDidUpdate(prevProps: any, prevState: any) {
		if (
			prevState.page !== this.state.page ||
			prevState.pageSize !== this.state.pageSize ||
			prevState.searchText !== this.state.searchText
		) {
			this.getData();
		}
	}

	async getData() {
		this.setState({ loading: true });
		const { page, pageSize, searchText } = this.state;
		let response: any;
		try {
			response = await API.get({
				url: Endpoints.uriPatients(),
				params: {
					page: page - 1, // API expects 0-based
					perPage: pageSize,
					search: searchText?.trim() || undefined
				}
			});
			if (response.ok) {
				this.setState({
					patients: response.data.results?.patients || [],
					total: response.data.results?.total || 0
				});
			} else {
				notification.error({
					message: Strings.sidebar.patients,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.patients,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}
		this.setState({ loading: false });
	}

	async startChat(user: any) {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		let response: any;
		try {
			let body = {
				user: user
			} as any;

			response = await API.patch({
				url: Endpoints.uriChats("start"),
				data: body
			});

			if (response.ok) {
				const { chat } = response.data.results;
				dispatch(push("/chat", { chatId: chat.socketId }));
			} else {
				notification.error({
					message: Strings.sidebar.chat,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.chat,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	handleSearchInput = (e: any) => {
		const value = e.target.value;
		this.setState({ searchInput: value });
		if (this.debounceTimer) clearTimeout(this.debounceTimer);
		this.debounceTimer = setTimeout(() => {
			this.setState({ page: 1, searchText: value });
		}, 750);
	};

	render() {
		const { patients, loading, page, pageSize, searchText, total, searchInput } = this.state;
		const { dispatch, language, mobile, user } = this.props;
		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.sidebar.patients} | Team24</title>
					<meta name="description" content="Description of patients" />
				</Helmet>
				<div className="CoworkersContent">
					<div className="MultiTitle">
						<h1>{Strings.sidebar.patients}</h1>
						{!mobile && (
							<div className="TableHeaderActions">
								<Input.Search
									id="table_search"
									value={searchInput}
									className="TableSearchInput"
									enterButton
									placeholder={Strings.generic.search}
									onChange={this.handleSearchInput}
								/>
							</div>
						)}
					</div>
					{mobile && (
						<div className="TableHeaderActions">
							<Input.Search
								id="table_search"
								value={searchInput}
								className="TableSearchInput"
								enterButton
								placeholder={Strings.generic.search}
								onChange={this.handleSearchInput}
							/>
						</div>
					)}
					<div className="CoworkersDivision">
						<ConfigProvider locale={language === "pt" ? pt : en}>
							<Table
								dataSource={patients}
								columns={
									user.isAdmin
										? [
											{
												title: Strings.fields.name,
												dataIndex: "name",
												render: (value: any) => <p>{value || "-"}</p>
											},
											{
												title: Strings.profile.psychologist,
												dataIndex: "psychologist",
												render: (value: any) => <p>{value || "-"}</p>
											},
											{
												title: Strings.fields.actions,
												align: "right",
												dataIndex: "_id",
												render: (user: any, row: any) => (
													<div className="TableActions">
														<Popconfirm
															title={Strings.chat.confirmStartChat}
															okText={Strings.chat.startChat}
															cancelText={Strings.appointments.cancel}
															okType="danger"
															placement="topRight"
															onConfirm={() => this.startChat(user)}
															onCancel={(e: any) => e.stopPropagation()}
														>
															<button>
																<Icons.ChatFilled color />
															</button>
														</Popconfirm>
														<button
															data-view
															onClick={() => dispatch(push(`/patients/${user}`))}
														>
															<Icons.Eye />
														</button>
													</div>
												),
												width: 100
											}
										]
									: [
										{
											title: Strings.fields.name,
											dataIndex: "name",
											render: (value: any) => <p>{value || "-"}</p>
										},
										{
											title: Strings.coworkers.business,
											dataIndex: "business",
											render: (value: any) => <p>{value || "-"}</p>
										},
										{
											title: Strings.fields.actions,
											align: "right",
											dataIndex: "_id",
											render: (user: any, row: any) => (
												<div className="TableActions">
													<Popconfirm
														title={Strings.chat.confirmStartChat}
														okText={Strings.chat.startChat}
														cancelText={Strings.appointments.cancel}
														okType="danger"
														placement="topRight"
														onConfirm={() => this.startChat(user)}
														onCancel={(e: any) => e.stopPropagation()}
													>
														<button>
															<Icons.ChatFilled color />
														</button>
													</Popconfirm>
													<button
														data-view
														onClick={() => dispatch(push(`/patients/${user}`))}
													>
														<Icons.Eye />
													</button>
												</div>
											),
											width: 100
										}
									]
								}
								rowKey={(row: any) => `row_${row._id}`}
								pagination={false}
								size="middle"
								loading={loading}
								className="CoworkersTable"
								sticky
							/>
						</ConfigProvider>
						<div className="CoworkersPagination">
							<Pagination
								total={total}
								current={page}
								pageSize={pageSize}
								onChange={(value: any) => this.setState({ page: value })}
								showSizeChanger
								onShowSizeChange={(current: any, size: any) => this.setState({ page: 1, pageSize: size })}
							/>
						</div>
					</div>
				</div>
				{mobile && <Footer />}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	language: state.language,
	mobile: state.mobile,
	user: state.user
});

export default connect(mapStateToProps)(Patients);
